import React, { useEffect, useState } from 'react';
import { validateEmail } from '../api';
import Button from '../components/core/Button';
import Wrapper from '../components/core/Wrapper';
import { handleGlobalApiCalls, syncUser } from '../helpers/asyncActions';
import { useGlobalContext } from '../stores/global';
import styles from './_endUser.module.scss';

export default function ValidateEmail(props: any) {
  const id = props.match?.params?.id;
  const code = props.match?.params?.code;
  const [emailState, setEmailState] = useState<'validated'>();
  const { dispatch, isLoading } = useGlobalContext();

  useEffect(() => {
    if (!id || !code) return;

    handleGlobalApiCalls(dispatch, isLoading, null, () =>
      validateEmail(id, code)
        .then(() => syncUser(dispatch))
        .then(() => setEmailState('validated'))
    );
  }, []);

  return (
    <Wrapper className={styles.wrapper} subHeader={{ title: 'Validar correo' }}>
      {emailState === 'validated' && (
        <>
          <i className="fonticons fonticons-checked" />
          <h2 className={styles.title}>Correo confirmado</h2>
          <p className={styles.desc}>
            Tu correo ha sido confirmado satisfactoriamente
          </p>
        </>
      )}
      <Button
        spanProps={{ className: styles.btn }}
        label="SALIR"
        onClick={() => (window.location.href = '/')}
      />
    </Wrapper>
  );
}
